export default class AuthenticatorServices {
    static isAuthenticated = false;

    static login(email, password) {
        const isAuthenticated = (email === "admin@afribonemali.net" && password === "admin");

        return new Promise(resolve => {
            setTimeout(() => {
                this.isAuthenticated = isAuthenticated;
                resolve(isAuthenticated);
            }, 1000);
        })
    }

    static logout() {
        const isAuthenticated = false;

        return new Promise(resolve => {
            setTimeout(() => {
                this.isAuthenticated = isAuthenticated;
                resolve(isAuthenticated);
            }, 1000);
        })
    }

}